import React from "react";

const Reports = () => {
  return (
    <div>
      <div className="page-header">
        <div>
          <h2>Reports</h2>
          <p>View sales, inventory and business reports.</p>
        </div>
      </div>

      <div className="dashboard-card bg-white p-4">
        <h5>Reports</h5>
        <p className="text-muted mb-0">
          Reports will be implemented here.
        </p>
      </div>
    </div>
  );
};

export default Reports;